import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'
import { notification } from 'antd'

export function useLpConfig() {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()

  const siteConfigQuery = useQuery({
    queryKey: ['best_buy/get_lp_config'],
    queryFn: async () => {
      const config = await api.post(`best_buy/get_lp_config`)
      return config as Gravitate.LpConfig
    },
    refetchOnWindowFocus: false,
  })

  const setConfigMutation = useMutation({
    mutationFn: (config: Gravitate.LpConfig) => api.post(`best_buy/set_lp_config`, config),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['best_buy/get_lp_config'],
      }),
    onError: () => notification.error({ message: 'Failed to save LP config' }),
  })

  return {
    config: siteConfigQuery.data ?? ({} as Gravitate.LpConfig),
    setConfig: setConfigMutation.mutate,
    isLoading: siteConfigQuery.isPending,
    isError: siteConfigQuery.isError,
  }
}
